import React, { useState, useEffect } from 'react';
import Block from './Block';

function Toiture() {
  const [toitureFormConfig, settoitureFormConfig] = useState(null);
  const [formData, setFormData] = useState({});
  const [submittedData, setSubmittedData] = useState(null);

  // 1. Charger la configuration depuis le localStorage au montage
  useEffect(() => {
    const config = localStorage.getItem('toitureFormConfig');
    if (config) {
      settoitureFormConfig(JSON.parse(config));
    }
  }, []);

  // 2. Gestion des changements de champ
  const handleChange = (e, fieldName) => {
    setFormData({
      ...formData,
      [fieldName]: e.target.value,
    });
  };

  // 3. Gestion de la soumission du formulaire
  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmittedData(formData); // tu pourrais aussi envoyer ça à une API
  };

  if (!toitureFormConfig) return <p>Chargement du formulaire...</p>;

  // const handleMoveField = (from, to) => {
  //   if (to < 0 || to >= toitureFormConfig.fields.length) return; // éviter les débordements
  //   const newFields = moveItem(toitureFormConfig.fields, from, to);
  //   settoitureFormConfig(newFields);
  // };

  // function moveItem(array, fromIndex, toIndex) {
  //   const updatedArray = [...array];
  //   const [movedItem] = updatedArray.splice(fromIndex, 1); // retire l'élément
  //   updatedArray.splice(toIndex, 0, movedItem); // insère à la nouvelle position
  //   return updatedArray;
  // }

  return (
    <>
        <div className="">
            <div className="container">
                {toitureFormConfig.fields.map((field, index) => (
                  <>
                    <Block
                      key={index}
                      blockTitle={field.title}
                      blockContent={field.products}
                      hasInput={field.hasInput}
                      inputLabel={field.inputLabel}
                      inputDescription={field.inputDescription}
                      type={field.type}
                      options={field.options}
                      value={formData[field.title] || ''} // on récupère la valeur actuelle
                      onChange={(e) => handleChange(e, field.title)} // on gère le changemen
                      order={field.order}
                    />
                    {/* <button onClick={() => handleMoveField(index, index - 1)}>⬆️ Monter</button>
                    <button onClick={() => handleMoveField(index, index + 1)}>⬇️ Descendre</button> */}
                  </>
                ))}

                <div className="container mt-5">
                    {/* <h2>{toitureFormConfig.title}</h2>
                    <p>{toitureFormConfig.description}</p> */}

                    {/* <form onSubmit={handleSubmit}>
                        {toitureFormConfig.fields.map((field, index) => (
                        <div key={index} className="mb-3">
                            <label className="form-label">{field.label}</label>

                            {field.type === 'text' || field.type === 'number' || field.type === 'date' || field.type === 'file' ? (
                            <input
                                type={field.type}
                                className="form-control"
                                value={formData[field.label] || ''}
                                onChange={(e) => handleChange(e, field.label)}
                            />
                            ) : field.type === 'select' ? (
                            <select
                                className="form-control"
                                value={formData[field.label] || ''}
                                onChange={(e) => handleChange(e, field.label)}
                            >
                                <option value="">-- Choisir une option --</option>
                                {(field.options || []).map((opt, i) => (
                                <option key={i} value={opt}>{opt}</option>
                                ))}
                            </select>
                            ) : null}
                        </div>
                        ))}

                        <button type="submit" className="btn btn-primary">Envoyer</button>
                    </form> */}

                    {submittedData && (
                        <div className="alert alert-success mt-4">
                        <h5>Données soumises :</h5>
                        <pre>{JSON.stringify(submittedData, null, 2)}</pre>
                        </div>
                    )}
                </div>
            </div>
        </div>
        
    </>
  );
}

export default Toiture;